import { gql } from "@apollo/client";
import RETAILER_FRAGMENT from '@/fragments/retailer';

const RETAILER_QUERY = gql`
	${RETAILER_FRAGMENT}
	query RetailerQuery( $retailerId: ID! ) {
		retailer( id: $retailerId ) {
			...retailerFragment
		}
	}
`;
export default RETAILER_QUERY;